import type { MePermissions, UserRole } from "./userRole";

export const enabledAuthProviders = ["github"] as const;

export type EnabledAuthProviderKind = (typeof enabledAuthProviders)[number];

// 로그인 응답만으로 만들 수 있는 초기 세션. registry 신원은 아직 없다. `/v1/me` 응답으로
// 채운 뒤에 `AuthSession` 이 된다(`updateAuthSessionFromProfile`).
export type AuthSessionSeed = Pick<
  AuthSession,
  "provider" | "accessToken" | "accessTokenExpiresAt"
>;

export type AuthSession = {
  provider: EnabledAuthProviderKind;
  uid: string;
  memberUuid: string | null;
  displayName: string;
  email: string | null;
  role: UserRole;
  // 서버가 산출한 공유 삭제 권한. 앱 초기화 때 /v1/me 로 갱신한다. login 직후와 복원 세션에는
  // 아직 없을 수 있다(persist 는 permissions 를 담지 않는다). 그래서 optional/null 로 둔다.
  // 로딩 전 구간에서는 소비처가 등급으로 폴백한다.
  permissions?: MePermissions | null;
  // 사용자가 고른 알림 수신 이메일. permissions 와 수명이 같다. /v1/me 로만 채우고 persist 하지
  // 않는다. 로딩 전과 미설정은 모두 null 이다. 소비처(알림 토글·제출 시드)는 null 을 "수신자
  // 아님"으로 해석한다.
  notificationEmail?: string | null;
  accessToken: string;
  accessTokenExpiresAt: string | null;
};
